import * as React from 'react'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { HubFramework } from '../../HubFramework'
import { HubPathRouting } from '../../HubFramework/pathBuilder'
import { getModuleInstanceInformation } from '../../BackendFacade/moduleCalls'
import { IModule } from '../../BackendFacade/IModuleInstances'
import { moduleContent } from './moduleContent'
import { DpasDataContext } from './dpasDataContext'

export const Module: React.FC = () => {
  HubPathRouting.setProject()
  HubPathRouting.setModule()

  const [dpasId, setDpasId] = useState<string>('')

  const getProjectId = useCallback(async (): Promise<string> => {
    if (dpasId !== '') {
      return dpasId
    }

    const projectId = HubPathRouting.currentProject.id
    const moduleId = HubPathRouting.currentModule.id

    const data = await getModuleInstanceInformation(projectId, moduleId)
    if (data.success) {
      const module = data.data.value as IModule
      const linkedId = module.linkedId.projectId
      setDpasId(linkedId)
      return linkedId
    }

    return ''
  }, [dpasId])

  const contextValue = useMemo(
    () => ({
      dpasId,
      getProjectId,
      setDpasId
    }),
    [dpasId, getProjectId]
  )

  return (
    <DpasDataContext.Provider value={contextValue}>
      <HubFramework hubContent={moduleContent} module={contextValue} />
    </DpasDataContext.Provider>
  )
}
